<template>
    <div>
        <app-autocomplete
            placeholder="Cliente"
            :items="clients"
            v-model="selectClient"
        />
        <!-- <app-clients-select-input
            v-model="clientId"
            :label="true"
            :placeholder="false"
            @change="!!clientId?loadVisitors(clientId):''"
        /> -->
        <b-tabs>
            <b-tab title="Ingreso de peatones" active>
                <b-card>
                    <app-visitors-walkers-page :client-id="clientId" />
                </b-card>
            </b-tab>
            <b-tab title="Ingreso de vehículos">
                <b-card>
                    <app-visitors-vehicles-page :client-id="clientId" />
                </b-card>
            </b-tab>
        </b-tabs>
    </div>
</template>
<script>
import VisitorsVehiclesPage from "./Vehicles/VisitorsVehiclesPage.vue";
import VisitorsWalkersPage from "./Walkers/VisitorsWalkersPage.vue";
import Autocomplete from "../../UI/Controls/AutocompleteV2/Autocomplete.vue";
import vehiclesRepository from "../../../repositories/vehicles.repository";
import { mapGetters } from "vuex";
export default {
    components: {
        appVisitorsVehiclesPage: VisitorsVehiclesPage,
        appVisitorsWalkersPage: VisitorsWalkersPage,
        appAutocomplete: Autocomplete
    },
    data() {
        return {
            selectClient: "",
            clientId: 0,
            page: 1,
            visitorsVehicles: {},
            visitorsWalkers: {},
            filtersVisitorsVehicles: null,
            filtersVisitorsWalkers: null
        };
    },

    watch: {
        selectClient(val) {
            if (!val) {
                this.clientId = 0;
                this.selectClient = "";
            } else {
                this.clientId = val.id;
                this.loadVisitors(this.clientId);
            }
        }
    },
    computed: {
        ...mapGetters(["clients"])
    },
    methods: {
        loadVisitors() {
            // this.loadVehicleEntries();
        },
        loadVehicleEntries() {
            const vr = Object.assign({}, vehiclesRepository);

            vr.getVehicleEntriesByClient(
                this.clientId,
                this.page,
                this.filtersVisitorsVehicles
            )
                .then(data => {
                    this.visitorsVehicles = data;
                })
                .catch(error => {
                    toastr.error(
                        "Ocurrió un error al cargar la información de ingresos"
                    );
                });
        },
        onChangePageVehicleEntries(page) {
            this.page = page;
            this.loadVehicleEntries();
        },
        onFilterVehicleEntries(filters) {
            this.filtersVisitorsVehicles = filters;
            this.page = 1;
            this.loadVehicleEntries();
        },
        cancelFilterVehicleEntries(filters) {
            this.page = 1;
            this.filtersVisitorsVehicles = filters;
            this.loadVehicleEntries();
        }
    },
    created() {
        this.load("clients");
    }
};
</script>
